import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { GetTeamSyncStatuses } from '../../../typings';

export function getTeamSyncStatuses(teamIds: Array<number> | string): Promise<GetTeamSyncStatuses> {
    const { apiGetTeamSyncStatuses } = apiConfig.getStaticUrls();

    return getFetch(apiGetTeamSyncStatuses, { teamIds });
}
